module.exports = __webpack_public_path__ + "static/media/syringe.90891e53.svg";